import TriggerSerializer from 'eflex/serializers/trigger';

export default class AdamIoTriggerSerializer extends TriggerSerializer {}
